import { SaleTypeForPlan, SaleTypeForTerm } from "@/lib/gql/__generated__/graphql";

import type * as Shared from "@/components/features/items/discount/item/multi/_shared";

import type * as DiscountItemMultiShared from "../../../../../_shared";

type InputModel = DiscountItemMultiShared.Model.ModelType.DiscountMultiFormModel["InputModel"];

export const serverModelToInputModelConverter = (
	hotelID: string,
	duplicateDiscountID: string | undefined,
	serverModel?: Shared.Model.Repository.Query.DiscountMultiNewItemForMultiServerModel,
): InputModel => {
	if (!serverModel?.discountMultiNewItem) {
		return {
			hotelID,
			discountID: duplicateDiscountID ?? "",
			// 基本設定
			// 公開・非公開
			inSale: false,
			// ディスカウントの名前
			name: "",
			// ディスカウントの説明
			description: "",
			// ディスカウントのコード
			discountCode: "",

			// 適用ディスカウント
			multiDiscounts: [],

			// 追加設定
			// キャンセル不可にするか
			isUncancelable: false,
			// 販売タイプ
			saleTypeForPlan: SaleTypeForPlan.Limited,
			// 利用可能期間
			saleTypeForTerm: SaleTypeForTerm.Always,
		} satisfies InputModel;
	}

	return serverModel.discountMultiNewItem satisfies InputModel;
};
